module.exports = __webpack_public_path__ + "media/theme/collection__nintendo-eed6e2b9.png";